"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_window_1 = require("react-window");
var SuggestItem_1 = require("./SuggestItem");
var helpers_1 = require("./helpers");
var defaultOptionRenderer_1 = require("./renderer/defaultOptionRenderer");
var emptyMessageRenderer_1 = require("./renderer/emptyMessageRenderer");
var optionContainerRenderer_1 = require("./renderer/optionContainerRenderer");
var StackView_1 = require("../StackView");
var helpers_2 = require("../helpers");
var Menu_1 = require("../Menu");
var ITEM_HEIGHT = 32;
var MAX_LIST_HEIGHT = ITEM_HEIGHT * 10;
var VIRTUAL_LIST_DEFAULT_WIDTH = 272;
var VIRTUAL_LIST_LIMIT = 100;
var INNER_LIST_WIDTH_GAP = 1 + 1;
var List = styled_components_1.default(StackView_1.StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-height: ", "px;\n    overflow-y: ", ";\n"], ["\n    max-height: ", "px;\n    overflow-y: ", ";\n"])), MAX_LIST_HEIGHT, function (_a) {
    var hasScroll = _a.hasScroll;
    return (hasScroll ? 'scroll' : 'auto');
});
function defaultSearchFilter(item, params) {
    var text = params.textGetter(item);
    return new RegExp("" + helpers_1.escapeRegExpString(params.searchTerm), 'gi').test(String(text || ''));
}
exports.defaultSearchFilter = defaultSearchFilter;
function defaultSearchSorter(data, params) {
    var itemsWithZeroPositionOfSearchTerm = [];
    var itemsWithNoZeroPositionOfSearchTerm = [];
    data.map(function (item) {
        var text = params.textGetter(item);
        var positionOfSearchTerm = String(text || '').search(new RegExp("" + helpers_1.escapeRegExpString(params.searchTerm), 'gi'));
        if (positionOfSearchTerm === 0) {
            itemsWithZeroPositionOfSearchTerm.push(item);
        }
        if (positionOfSearchTerm !== 0) {
            itemsWithNoZeroPositionOfSearchTerm.push(item);
        }
    });
    return __spreadArrays(itemsWithZeroPositionOfSearchTerm, itemsWithNoZeroPositionOfSearchTerm);
}
exports.defaultSearchSorter = defaultSearchSorter;
var defaultOptionRenderer = defaultOptionRenderer_1.createDefaultOption();
var defaultOptionContainerRenderer = optionContainerRenderer_1.createOptionContainerRenderer();
var defaultEmptyRenderer = emptyMessageRenderer_1.createEmptyMessageRenderer({
    text: 'No options found'
});
exports.Suggest = helpers_2.createUIElement('Suggest', function (_a, ref) {
    var className = _a.className, data = _a.data, widthSize = _a.widthSize, _b = _a.renderEmptyMessage, renderEmptyMessage = _b === void 0 ? defaultEmptyRenderer : _b, filter = _a.filter, _c = _a.searchFilter, searchFilter = _c === void 0 ? defaultSearchFilter : _c, _d = _a.searchSorter, searchSorter = _d === void 0 ? defaultSearchSorter : _d, renderTrailerItem = _a.renderTrailerItem, textGetter = _a.textGetter, searchTerm = _a.searchTerm, selectedIndex = _a.selectedIndex, onSelect = _a.onSelect, _e = _a.optionRenderer, optionRenderer = _e === void 0 ? defaultOptionRenderer : _e, _f = _a.optionContainerRenderer, optionContainerRenderer = _f === void 0 ? defaultOptionContainerRenderer : _f, onItemMouseDown = _a.onItemMouseDown, isOptionDisabled = _a.isOptionDisabled, _g = _a.hasVirtualization, hasVirtualization = _g === void 0 ? false : _g, _h = _a.virtualListLimit, virtualListLimit = _h === void 0 ? VIRTUAL_LIST_LIMIT : _h, _j = _a.virtualListWidth, virtualListWidth = _j === void 0 ? VIRTUAL_LIST_DEFAULT_WIDTH : _j, onMouseDown = _a.onMouseDown, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "data", "widthSize", "renderEmptyMessage", "filter", "searchFilter", "searchSorter", "renderTrailerItem", "textGetter", "searchTerm", "selectedIndex", "onSelect", "optionRenderer", "optionContainerRenderer", "onItemMouseDown", "isOptionDisabled", "hasVirtualization", "virtualListLimit", "virtualListWidth", "onMouseDown", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var virtualListRef = react_1.useRef(null);
    var suggestData = filter ? data.filter(filter) : data;
    if (searchTerm) {
        suggestData = suggestData.filter(function (item) {
            return searchFilter(item, { searchTerm: searchTerm, textGetter: textGetter });
        });
        suggestData = searchSorter(suggestData, { searchTerm: searchTerm, textGetter: textGetter });
    }
    var suggestDataState = helpers_2.useStateValue(suggestData, [suggestData]);
    var calcWillSelectIndexBySelectedIndexAndSuggestDataState = function () {
        return typeof selectedIndex === 'number' && selectedIndex < data.length
            ? suggestDataState.getValue().indexOf(data[selectedIndex])
            : -1;
    };
    var _k = helpers_2.useStateValue(calcWillSelectIndexBySelectedIndexAndSuggestDataState(), [selectedIndex]), getWillSelectIndex = _k.getValue, setWillSelectIndexValue = _k.setValue;
    var setWillSelectIndex = function (index) {
        setWillSelectIndexValue(index);
        if (virtualListRef.current) {
            virtualListRef.current.scrollToItem(index);
        }
    };
    react_1.useEffect(function () {
        setWillSelectIndex(calcWillSelectIndexBySelectedIndexAndSuggestDataState());
    }, [searchTerm]);
    var selectByIndex = function (filterDataIndex) {
        var selectedValue = suggestDataState.getValue()[filterDataIndex];
        var dataValueIndex = data.indexOf(selectedValue);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedValue, dataValueIndex);
    };
    var isEmptyFilteredMenu = function () {
        return suggestDataState.getValue().length === 0;
    };
    // listRef.current.scrollToItem(200);
    react_1.useEffect(function () {
        var handler = function (event) {
            var suggestData = suggestDataState.getValue();
            var selectedIndex = getWillSelectIndex();
            if (event.keyCode === helpers_2.KeyCode.DownArrow) {
                if (isEmptyFilteredMenu()) {
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
                if (selectedIndex < 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    setWillSelectIndex(0);
                    return;
                }
                if (selectedIndex === suggestData.length - 1) {
                    event.stopPropagation();
                    event.preventDefault();
                    setWillSelectIndex(-1);
                    return;
                }
                event.stopPropagation();
                setWillSelectIndex(selectedIndex + 1);
            }
            if (event.keyCode === helpers_2.KeyCode.UpArrow) {
                if (isEmptyFilteredMenu()) {
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
                if (selectedIndex < 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    setWillSelectIndex(suggestData.length - 1);
                    return;
                }
                if (selectedIndex === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    setWillSelectIndex(-1);
                    return;
                }
                event.stopPropagation();
                setWillSelectIndex(selectedIndex - 1);
            }
            if (event.keyCode === helpers_2.KeyCode.Enter || event.keyCode === helpers_2.KeyCode.Space) {
                if (selectedIndex > -1 &&
                    !(isOptionDisabled === null || isOptionDisabled === void 0 ? void 0 : isOptionDisabled(suggestDataState.getValue()[selectedIndex]))) {
                    event.stopPropagation();
                    event.preventDefault();
                    selectByIndex(selectedIndex);
                }
            }
        };
        if (document) {
            document.addEventListener('keydown', handler, true);
        }
        return function () {
            if (document) {
                document.removeEventListener('keydown', handler, true);
            }
        };
    }, []);
    var suggestDataList = suggestDataState.getValue();
    var hasVirtualScroll = hasVirtualization && suggestDataList.length > virtualListLimit;
    react_1.useEffect(function () {
        if (hasVirtualScroll && selectedIndex && virtualListRef.current) {
            //virtualListRef.current?.scrollToItem(selectedIndex, 'center');
        }
    }, []);
    var willSelectIndex = getWillSelectIndex();
    var renderRow = react_1.useCallback(function (_a) {
        var style = _a.style, index = _a.index;
        var _b;
        var item = suggestDataList[index];
        var text = (_b = textGetter === null || textGetter === void 0 ? void 0 : textGetter(item)) !== null && _b !== void 0 ? _b : '';
        var isDisabled = isOptionDisabled === null || isOptionDisabled === void 0 ? void 0 : isOptionDisabled(item);
        return (react_1.default.createElement(SuggestItem_1.SuggestItem, { style: style, option: item, highlightPattern: searchTerm, key: text + ":" + index, text: String(text), hovered: willSelectIndex == index, selected: data.indexOf(item) === selectedIndex, disabled: isDisabled, contentRenderer: optionRenderer, containerRenderer: optionContainerRenderer, onMouseDown: function (e) {
                if (!e.button && !isDisabled) {
                    onItemMouseDown === null || onItemMouseDown === void 0 ? void 0 : onItemMouseDown();
                    selectByIndex(index);
                }
            } }));
    }, [
        suggestDataList,
        optionRenderer,
        optionContainerRenderer,
        isOptionDisabled,
        textGetter,
        selectedIndex,
        willSelectIndex
    ]);
    var listItems = suggestDataList.map(function (item, idx) {
        return renderRow({ style: {}, index: idx });
    });
    if (!listItems.length) {
        listItems.push(react_1.default.createElement(react_1.default.Fragment, { key: 'empty message' }, renderEmptyMessage()));
    }
    if (!hasVirtualScroll && typeof renderTrailerItem === 'function') {
        listItems.push(react_1.default.createElement(react_1.default.Fragment, { key: 'trailer-item' }, renderTrailerItem({ searchTerm: searchTerm })));
    }
    var listContent = (react_1.default.createElement(react_1.default.Fragment, { key: 'list-content' }, listItems));
    if (hasVirtualScroll) {
        listContent = (react_1.default.createElement(react_window_1.FixedSizeList, { ref: virtualListRef, height: MAX_LIST_HEIGHT, itemCount: listItems.length, itemSize: ITEM_HEIGHT, initialScrollOffset: (selectedIndex || 0) * ITEM_HEIGHT, width: virtualListWidth - INNER_LIST_WIDTH_GAP }, renderRow));
    }
    var hasScroll = !hasVirtualScroll && listItems.length > 10;
    return (react_1.default.createElement(Menu_1.Menu, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'suggest', className: "vm-Suggest " + className, widthSize: widthSize, tabIndex: -1, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: function (e) {
            e.stopPropagation();
            e.preventDefault();
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(List, { direction: StackView_1.STACK_DIRECTION.column, onKeyDown: function (e) {
                e.preventDefault();
            }, align: StackView_1.STACK_ALIGN.fill, hasScroll: hasScroll }, listContent)));
});
var templateObject_1;
//# sourceMappingURL=Suggest.js.map